import { useAssignedStoreTemplateUpdateQueries } from "./useAssignedStoreTemplateUpdateQueries";

export const useAssignedStoreTemplateUpdate = ({setAssignedStoreState,templateId,templates}) =>
{
    const {updateTemplateStore} = useAssignedStoreTemplateUpdateQueries({setAssignedStoreState,templateId,templates});
    return {updateTemplateStore};
}